import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { routeList } from "../Data/routesList";
import { useSelector } from 'react-redux';

const useQuery = () => new URLSearchParams(useLocation().search);

const Searchpage = () => {
  const query = useQuery().get("query") || "";
  const [filteredResults, setFilteredResults] = useState([]);
  const navigate = useNavigate();
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: 'Search Results',
      breadcrumb: {
        home: 'HOME',
        page: 'SEARCH RESULT'
      },
      noResults: 'No results found for',
    },

    मराठी: {
      title: 'शोध निकाल',
      breadcrumb: {
        home: 'मुख्यपृष्ठ ',
        page: 'शोध निकाल'
      },
      noResults: 'कोणतेही परिणाम सापडले नाहीत',
    },
  };

  const t = content[selectedLang];

  useEffect(() => {
    const searchKeyword = query.trim().toLowerCase();

    if (searchKeyword === "") {
      setFilteredResults([]);
      return;
    }

    const matchedRoutes = routeList.filter((route) => {
      const title = route.title[selectedLang];
      return title.toLowerCase().includes(searchKeyword);
    });

    setFilteredResults(matchedRoutes);
  }, [query, selectedLang]);

  return (
    <div className="min-h-screen bg-[#f8f7f0] px-4 py-10">
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-4">
          <Link to="/" className="hover:underline" style={{ color: "#DD9827" }}>
            {t.breadcrumb.home} /
          </Link>{" "}
          {t.breadcrumb.page}
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        {/* Search input (read-only) */}
        <div className="flex items-center border rounded px-4 py-2 bg-white shadow-sm w-full sm:w-1/2 mx-auto search-container">
          <FaSearch className="text-gray-500 mr-2" />
          <span className="text-gray-400 text-sm mr-2">|</span>
          <input
            type="text"
            value={query}
            readOnly
            className="flex-1 text-base outline-none bg-transparent text-gray-600"
          />
        </div>

        <h2 className="text-2xl text-left font-serif mt-8 mb-4 text-gray-800">
          {t.title}
        </h2>

        {/* Results */}
        <div className="space-y-4 text-left">
          {filteredResults.length > 0 ? (
            filteredResults.map((item, index) => (
              <button
                key={item.id}
                type="button"
                onClick={() => navigate(item.path)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(item.path);
                  }
                }}
                className="w-full text-left border-b border-orange-100 pb-4 cursor-pointer hover:bg-orange-50 px-2 py-2 rounded text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-300"
              >
                <h3 className="font-medium text-lg">{item.title[selectedLang]}</h3>
              </button>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-4">
              {t.noResults} "<strong>{query}</strong>"
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Searchpage;
